import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Loader } from '@independent-software/typeui/controls/Loader';
import { Icon } from '@independent-software/typeui/controls/Icon';
import { ToastService } from '@independent-software/typeui/controls/Toast';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { UserForm } from './UserForm';
import { UserFactory, User } from '../../resource/';

type TStep = 'ready' | 'saving' | 'saveError';

const AddUser = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  const user = React.useRef(UserFactory.create());
  const [step, setStep] = React.useState('ready' as TStep);
  const [valid, setValid] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [formData, setFormData] = React.useState(user.current);
  const [dirty, setDirty] = React.useState(false);

  const handleChange = (data: User, forceupdate: boolean) => {
    user.current = Object.assign(user.current, data);
    if(forceupdate) setFormData({...data as any});
  }

  const handleValidate = (_valid: boolean) => setValid(_valid);
    
  const handleSubmit = () => {
    setFormData(user.current);
    setDirty(true);
    if(!valid) return;    
    setError(null);
    setStep('saving');

    user.current.$save(auth)
    .then(_ => {
      ToastService.toast("User created.");
      navigate("/users");
    })
    .catch(error => {
      setStep('saveError');
      setError(error);
    });
  }

  const handleCancelSave = () => setStep('ready');

  return (
    <Container>
      {step == 'saving' && <Loader></Loader>}
      <React.Fragment>
        <Content>
          <UserForm dirty={dirty} data={formData} onChange={handleChange}  onValidate={handleValidate}/>
        </Content>
        <BottomBar>
          <Button primary disabled={!valid} onClick={handleSubmit}><Icon name="save"/> Save</Button>
          <Button secondary onClick={() => navigate(-1)}>Cancel</Button>
        </BottomBar>
      </React.Fragment>
      <Dialog.Xhr open={step == 'saveError'} error={error} onClose={handleCancelSave} onRetry={handleSubmit}/>
    </Container>
  );
}

export { AddUser }
